// Copyright (c) 2016 Deere & Company

import {combineReducers} from 'redux';
import details from '../../details/reducers';

export default {
    customer: combineReducers({
        ...details
    })
};



// WEBPACK FOOTER //
// ./src/customer/shared/reducers/index.js